import { CONSTANT } from "../../utils/Constant";
import { privateFetch } from "../../utils/CustomFetch";

export const sendEmailViaGraph = async (data) => {
  const response = await privateFetch.post(
    "notification/email/send",
    data,
    { headers: { ...CONSTANT.HEADER_TYPE } }
  );
  return response.data;
};

export const getEmailMessages = async (clientId, userId) => {
  const params = (userId !== null && userId !== undefined) ? { userId } : {};
  const response = await privateFetch.get(
    `notification/email/messages/${clientId}`,
    { headers: { ...CONSTANT.HEADER_TYPE }, params }
  );
  return response.data;
};

export const markEmailsSeen = async (clientId) => {
  await privateFetch.post(
    `notification/email/seen/${clientId}`,
    {},
    { headers: { ...CONSTANT.HEADER_TYPE } }
  );
};

export const getEmailUnreadCount = async (userId) => {
  const response = await privateFetch.get(
    `notification/email/unread-count/${userId}`,
    { headers: { ...CONSTANT.HEADER_TYPE } }
  );
  return response.data;
};

export const getEmailUnreadCounts = async () => {
  const response = await privateFetch.get(
    `notification/email/unread-counts`,
    { headers: { ...CONSTANT.HEADER_TYPE } }
  );
  return response.data; // Map<clientId, count>
};

export const getEmailAttachments = async (emailMessageId) => {
  const response = await privateFetch.get(
    `notification/email/messages/${emailMessageId}/attachments`,
    { headers: { ...CONSTANT.HEADER_TYPE } }
  );
  return response.data; // List<{ name, contentType, contentBytes }>
};

export const sendEmailMassive = async ({ subject, body, fromEmail, userId, clientIds }) => {
  const response = await privateFetch.post(
    "notification/email/send-massive",
    { subject, body, fromEmail, userId, clientIds },
    { headers: { ...CONSTANT.HEADER_TYPE } }
  );
  return response.data; // { sent: N, skipped: M, errors: K }
};
